import { AuthLayout } from 'components/AuthLayout/AuthLayout';
import { CompanyLayout } from 'components/Layouts/CompanyLayout';
import { DocumentsLayout } from 'components/Layouts/DocumentsLayout';
import { EventLayout } from 'components/Layouts/EventLayout';
import { Layout } from 'components/Layouts/Layout';
import { MemberLayout } from 'components/Layouts/MemberLayout';
import { StaffLayout } from 'components/Layouts/StaffLayout';
import Cookies from 'js-cookie';
import { AccountingExport } from 'pages/Accounting/AccountingExport';
import { Announcement } from 'pages/Announcement/Announcement';
import { CompaniesList } from 'pages/CompaniesList/CompaniesList';
import { CompanyConsumptions } from 'pages/CompanyConsumptions/CompanyConsumptions';
import { CompanyContacts } from 'pages/CompanyContacts/CompanyContacts';
import { CompanyInvoices } from 'pages/CompanyInvoices/CompanyInvoices';
import { CompanyPreview } from 'pages/CompanyPreview/CompanyPreview';
import { CompanyProfile } from 'pages/CompanyProfile/CompanyProfile';
import { CompanyTransactions } from 'pages/CompanyTransactions/CompanyTransactions';
import { ConsumptionPeriodsList } from 'pages/ConsumptionPeriods/ConsumptionPeriodsList';
import { Consumptions } from 'pages/Consumptions/Consumptions';
import { ContactsList } from 'pages/ContactsList/ContactsList';
import { Dashboard } from 'pages/Dashboard/Dashboard';
import { EditAnnouncement } from 'pages/EditAnnouncement/EditAnnouncement';
import { EditCompany } from 'pages/EditCompany/EditCompany';
import { EditEvent } from 'pages/EditEvent/EditEvent';
import { EditInformation } from 'pages/EditInformation/EditInformation';
import { EditMember } from 'pages/EditMember/EditMember';
import { EditPartner } from 'pages/EditPartner/EditPartner';
import { EditStaff } from 'pages/EditStaff/EditStaff';
import { EventPreview } from 'pages/EventPreview/EventPreview';
import { EventsList } from 'pages/EventsList/EventsList';
import { ForgotPassword } from 'pages/ForgotPassword/ForgotPassword';
import { ImportWizard } from 'pages/Import/ImportWizard';
import { Information } from 'pages/Information/Information';
import { InvoiceDetail } from 'pages/Invoices/InvoiceDetail';
import { InvoiceEditor } from 'pages/Invoices/InvoiceEditor';
import { Invoices } from 'pages/Invoices/Invoices';
import { InvoicesList } from 'pages/Invoices/InvoicesList';
import { Login } from 'pages/Login/Login';
import { Logout } from 'pages/Logout/Logout';
import { MemberConsumptions } from 'pages/MemberConsumptions/MemberConsumptions';
import { MemberContacts } from 'pages/MemberContacts/MemberContacts';
import { MemberEvents } from 'pages/MemberEvents/MemberEvents';
import { MemberInvoices } from 'pages/MemberInvoices/MemberInvoices';
import { MemberPartner } from 'pages/MemberPartner/MemberPartner';
import { MemberPreview } from 'pages/MemberPreview/MemberPreview';
import { MemberProfile } from 'pages/MemberProfile/MemberProfile';
import { MembersList } from 'pages/MembersList/MembersList';
import { NewCompany } from 'pages/NewCompany/NewCompany';
import { NewEvent } from 'pages/NewEvent/NewEvent';
import { NewMember } from 'pages/NewMember/NewMember';
import { NewStaff } from 'pages/NewStaff/NewStaff';
import { ProfileChangesList } from 'pages/ProfileChanges/ProfileChangesList';
import { AvailabilityGrid } from 'pages/Reservations/AvailabilityGrid';
import { EntitiesList } from 'pages/Reservations/Entities/EntitiesList';
import { EntityTypesList } from 'pages/Reservations/EntityTypes/EntityTypesList';
import { LocationsList } from 'pages/Reservations/Locations/LocationsList';
import { ReservationCalendar } from 'pages/Reservations/ReservationCalendar';
import { ResetPassword } from 'pages/ResetPassword/ResetPassword';
import { TwoFactorSettings } from 'pages/Security/TwoFactorSettings';
import { StaffList } from 'pages/StaffList/StaffList';
import { StaffProfile } from 'pages/StaffProfile/StaffProfile';
import { TagsList } from 'pages/Tags/TagsList';
import React from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';

export enum AppRoutes {
    login = '/login',
    logout = '/logout',
    forgotPassword = '/forgot-password',
    resetPassword = '/password-reset',
    dashboard = '/',
    members = '/members',
    newMember = '/members/new',
    memberLayout = '/members',
    memberPreview = '/members/:id',
    memberProfile = '/members/:id/profile',
    editMember = '/members/:id/profile/edit',
    memberPartner = '/members/:id/partner',
    memberEditPartner = '/members/:id/partner/edit',
    memberContacts = '/members/:id/contacts',
    memberEvents = '/members/:id/events',
    companies = '/members/companies',
    companyPreview = '/members/companies/:id',
    companyProfile = '/members/companies/:id/profile',
    editCompany = '/members/companies/:id/profile/edit',
    newCompany = '/members/companies/new',
    companyContacts = '/members/companies/:id/contacts',
    companyInvoices = '/members/companies/:id/invoices',
    companyTransactions = '/members/companies/:id/transactions',
    contacts = '/members/contacts',
    staff = '/staff',
    newStaff = '/staff/new',
    staffProfile = '/staff/:id/profile',
    editStaff = '/staff/:id/edit',
    events = '/events',
    event = '/event',
    eventPreview = '/events/:id',
    newEvent = '/events/new',
    editEvent = '/events/:id/edit',
    announcement = '/announcement',
    editAnnouncement = '/announcement/edit',
    consumptions = '/documents/consumptions',
    companyConsumptions = '/documents/company-consumptions',
    memberDocumentConsumptions = '/documents/consumptions/:id',
    memberConsumptions = '/members/:id/consumptions',
    documents = '/documents',
    invoices = '/documents/invoices',
    memberDocumentInvoices = '/documents/invoices/:id',
    memberInvoices = '/members/:id/invoices',
    information = '/information',
    newInformation = '/information/new',
    informationPreview = '/information/:id',
    editInformation = '/information/:id/edit',
    profileChanges = '/profile-changes',
    tags = '/tags',
    invoicesList = '/invoices',
    newInvoice = '/invoices/new',
    invoiceDetail = '/invoices/:id',
    editInvoice = '/invoices/:id/edit',
    reservationsLocations = '/reservations/locations',
    reservationsEntityTypes = '/reservations/entity-types',
    reservationsEntities = '/reservations/entities',
    reservationsCalendar = '/reservations/calendar',
    reservationsAvailability = '/reservations/availability',
    security = '/security',
    import = '/import',
    consumptionPeriods = '/consumption-periods',
    accountingExport = '/accounting/export',
}

const PriveteRoutes = () => {
    const auth = Cookies.get('token');

    return auth ? <Layout /> : <Navigate to={AppRoutes.login} />;
};
export const Routes = () => {
    return (
        <ReactRoutes>
            <Route element={<AuthLayout />}>
                <Route path={AppRoutes.login} element={<Login />} />
                <Route path={AppRoutes.forgotPassword} element={<ForgotPassword />} />
                <Route path={AppRoutes.resetPassword} element={<ResetPassword />} />
            </Route>
            <Route element={<PriveteRoutes />}>
                <Route path={AppRoutes.dashboard} element={<Dashboard />} />
                <Route path={AppRoutes.members} element={<MembersList />} />
                <Route path={AppRoutes.newMember} element={<NewMember />} />
                <Route path={AppRoutes.profileChanges} element={<ProfileChangesList />} />
                <Route path={AppRoutes.tags} element={<TagsList />} />
                <Route path={AppRoutes.security} element={<TwoFactorSettings />} />
                <Route path={AppRoutes.import} element={<ImportWizard />} />
                <Route path={AppRoutes.consumptionPeriods} element={<ConsumptionPeriodsList />} />
                <Route path={AppRoutes.accountingExport} element={<AccountingExport />} />
                <Route path={AppRoutes.invoicesList} element={<InvoicesList />} />
                <Route path={AppRoutes.newInvoice} element={<InvoiceEditor />} />
                <Route path={AppRoutes.invoiceDetail} element={<InvoiceDetail />} />
                <Route path={AppRoutes.editInvoice} element={<InvoiceEditor />} />
                <Route path={AppRoutes.reservationsLocations} element={<LocationsList />} />
                <Route path={AppRoutes.reservationsEntityTypes} element={<EntityTypesList />} />
                <Route path={AppRoutes.reservationsEntities} element={<EntitiesList />} />
                <Route path={AppRoutes.reservationsCalendar} element={<ReservationCalendar />} />
                <Route path={AppRoutes.reservationsAvailability} element={<AvailabilityGrid />} />
                <Route path={AppRoutes.memberLayout} element={<MemberLayout />}>
                    <Route path={AppRoutes.memberPreview} element={<MemberPreview />} />
                    <Route path={AppRoutes.memberProfile} element={<MemberProfile />} />
                    <Route path={AppRoutes.editMember} element={<EditMember />} />
                    <Route path={AppRoutes.memberPartner} element={<MemberPartner />} />
                    <Route path={AppRoutes.memberEditPartner} element={<EditPartner />} />
                    <Route path={AppRoutes.memberContacts} element={<MemberContacts />} />
                    <Route path={AppRoutes.memberEvents} element={<MemberEvents />} />
                    <Route path={AppRoutes.memberConsumptions} element={<MemberConsumptions />} />
                    <Route path={AppRoutes.memberInvoices} element={<MemberInvoices />} />
                </Route>
                <Route path={AppRoutes.companies} element={<CompaniesList />} />
                <Route path={AppRoutes.newCompany} element={<NewCompany />} />
                <Route path={AppRoutes.companies} element={<CompanyLayout />}>
                    <Route path={AppRoutes.companyPreview} element={<CompanyPreview />} />
                    <Route path={AppRoutes.companyProfile} element={<CompanyProfile />} />
                    <Route path={AppRoutes.editCompany} element={<EditCompany />} />
                    <Route path={AppRoutes.companyContacts} element={<CompanyContacts />} />
                    <Route path={AppRoutes.companyInvoices} element={<CompanyInvoices />} />
                    <Route path={AppRoutes.companyTransactions} element={<CompanyTransactions />} />
                </Route>
                <Route path={AppRoutes.contacts} element={<ContactsList />} />
                <Route path={AppRoutes.staff} element={<StaffList />} />
                <Route path={AppRoutes.newStaff} element={<NewStaff />} />
                <Route path={AppRoutes.staff} element={<StaffLayout />}>
                    <Route path={AppRoutes.staffProfile} element={<StaffProfile />} />
                    <Route path={AppRoutes.editStaff} element={<EditStaff />} />
                </Route>
                <Route path={AppRoutes.events} element={<EventsList />} />
                <Route path={AppRoutes.newEvent} element={<NewEvent />} />
                <Route path={AppRoutes.events} element={<EventLayout />}>
                    <Route path={AppRoutes.eventPreview} element={<EventPreview />} />
                    <Route path={AppRoutes.editEvent} element={<EditEvent />} />
                </Route>
                <Route path={AppRoutes.announcement} element={<Announcement />} />
                <Route path={AppRoutes.editAnnouncement} element={<EditAnnouncement />} />
                <Route path={AppRoutes.information} element={<Information />} />
                <Route path={AppRoutes.newInformation} element={<EditInformation />} />
                <Route path={AppRoutes.editInformation} element={<EditInformation />} />
                <Route path={AppRoutes.documents} element={<DocumentsLayout />}>
                    <Route path={AppRoutes.invoices} element={<Invoices />} />
                    <Route path={AppRoutes.consumptions} element={<Consumptions />} />
                    <Route path={AppRoutes.companyConsumptions} element={<CompanyConsumptions />} />
                    <Route path={AppRoutes.memberDocumentConsumptions} element={<MemberConsumptions />} />
                    <Route path={AppRoutes.memberDocumentInvoices} element={<MemberInvoices />} />
                </Route>
            </Route>
            <Route path={AppRoutes.logout} element={<Logout />} />
            <Route path="*" element={<Navigate to={AppRoutes.dashboard} />} />
        </ReactRoutes>
    );
};
